import React, { useState } from 'react';

interface PropertyImageGalleryProps {
  images: string[];
  title: string;
}

const PropertyImageGallery: React.FC<PropertyImageGalleryProps> = ({ images, title }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  console.log(`PropertyImageGallery - Images:`, images, `Title:`, title);

  // Handle case where there are no images
  if (!images || images.length === 0) {
    return (
      <div className="bg-white rounded-xl overflow-hidden shadow-lg">
        <div className="relative h-96 md:h-[500px] bg-gray-200 flex items-center justify-center">
          <div className="text-center">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">No images</h3>
            <p className="mt-1 text-sm text-gray-500">This property does not have any images yet.</p>
          </div>
        </div>
        <div className="p-4">
          <p className="text-gray-500 text-center">No images to display</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-lg">
      <div className="relative h-96 md:h-[500px]">
        <img
          src={images[selectedImage]}
          alt={title}
          className="w-full h-full object-cover"
          onError={(e) => {
            console.error(`Failed to load image:`, images[selectedImage], e);
          }}
          onLoad={() => {
            console.log(`Successfully loaded image:`, images[selectedImage]);
          }}
        />
      </div>
      <div className="flex gap-2 p-4 overflow-x-auto">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden border-2 transition-all ${
              selectedImage === index ? 'border-blue-600' : 'border-gray-200 hover:border-gray-400'
            }`}
          >
            <img
              src={image}
              alt={`View ${index + 1}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                console.error(`Failed to load thumbnail:`, image, e);
              }}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PropertyImageGallery;
